import { localStorage } from 'dibs-browser-storage';
import { trackEvent } from 'dibs-tracking';
import SV from 'server-vars';

const TRACKING_CATEGORY = 'trade onboarding';
const VIEW_COUNT_LOCAL_STORAGE_KEY = 'TRADE_GENERAL_ONBOARDING_MODAL_VIEW_COUNT';

const getViewCount = (): number => localStorage.getItem(VIEW_COUNT_LOCAL_STORAGE_KEY) || 0;

export function hasSeenTradeGeneralOnboarding(): boolean {
    return getViewCount() > 0;
}

export function logTradeGeneralOnboardingView(): void {
    localStorage.setItem(VIEW_COUNT_LOCAL_STORAGE_KEY, getViewCount() + 1);
    trackEvent({
        action: 'general trade modal displayed',
        category: TRACKING_CATEGORY,
        label: 'none',
    });
}

export function trackBudgetSelection(budget: string): void {
    trackEvent({
        action: 'budget selected',
        category: TRACKING_CATEGORY,
        label: budget,
    });
}

export function isDesktop(): boolean {
    return SV.get('settings.isDesktop') || false;
}

export function isUserTypeTrade(): boolean {
    return SV.get('settings.isUserTypeTrade') || false;
}
